// extracted by mini-css-extract-plugin
export var container = "ClipboardTextBox-module__container___V+wcW";
export var copyLabel = "ClipboardTextBox-module__copyLabel___1c72P";
export var copyLabelWrapper = "ClipboardTextBox-module__copyLabelWrapper___QqsD9";
export var textBar = "ClipboardTextBox-module__textBar___bpUEW";
export var title = "ClipboardTextBox-module__title___HHS68";